// v3.4.442 — «نظام أوامر الصرف»: صفحة واحدة بتابين — أوامر صرف اليوميات الأسبوعية + أوامر صرف مستحقات المقاولين
// كل تاب يظهر حسب صلاحيته؛ الروابط القديمة (/construction-orders و /construction-claims) تفتح هذه الصفحة على التاب المقابل.
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { PaymentOrdersPage, ContractClaimsPage } from "./ConstructionPage";
import { SupplyOrdersPanel } from "./SupplyContractsPage";
// v3.4.621 — تاب ثالث: أوامر صرف دفعات عقود التوريدات والخدمات الاستشارية (كل المشاريع)
function SupplyOrdersTab() { return <div style={{ padding: "12px 20px 30px" }}><div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 14, padding: 14 }}><SupplyOrdersPanel /></div></div>; }

const TABS = [
  { key: "weekly", icon: "💵", title: "أوامر صرف اليوميات الأسبوعية", sub: "العمالة اليومية لكل أسبوع", path: "/construction-orders", perm: "can_view_weekly_orders", Page: PaymentOrdersPage },
  { key: "claims", icon: "🧾", title: "أوامر صرف مستحقات المقاولين", sub: "مستخلصات مقاولي الباطن", path: "/construction-claims", perm: "can_view_contract_claims", Page: ContractClaimsPage },
  { key: "supply", icon: "📦", title: "أوامر صرف عقود التوريد والاستشارات", sub: "دفعات عقود التوريدات والخدمات الاستشارية", path: "/supply-orders", perm: "can_view_supply_contracts", Page: SupplyOrdersTab },
];

export default function PaymentOrdersHub() {
  const { user } = useAuth(); const location = useLocation(); const navigate = useNavigate();
  const isAdmin = user?.role === "admin" && !user?.impersonating; // نفس منطق القائمة الجانبية (المعاينة كمستخدم)
  const allowed = TABS.filter(t => isAdmin || user?.[t.perm]);
  if (!allowed.length) return <div style={{ padding: 40, textAlign: "center", color: "#b45309" }}>ليس لديك صلاحية على أوامر الصرف</div>;
  const active = allowed.find(t => location.pathname.startsWith(t.path)) || allowed[0];
  const { Page } = active;
  return (
    <div dir="rtl">
      <div style={{ padding: "16px 20px 0" }}>
        <div style={{ fontSize: 18, fontWeight: 900, color: "#0f172a", marginBottom: 10 }}>🧾 نظام أوامر الصرف</div>
        {/* v3.4.450 — تابات واضحة: بطاقتان كبيرتان، النشطة ممتلئة بلون الهوية */}
        <div role="tablist" style={{ display: "grid", gridTemplateColumns: `repeat(${allowed.length}, minmax(0, 1fr))`, gap: 10, background: "#f1f5f9", border: "1px solid #e2e8f0", borderRadius: 14, padding: 6, maxWidth: 1100 }}>
          {allowed.map(t => { const on = t.key === active.key; return (
            <button key={t.key} role="tab" aria-selected={on} type="button" onClick={() => !on && navigate(t.path)}
              onMouseEnter={e => { if (!on) { e.currentTarget.style.background = "#fff"; e.currentTarget.style.color = "#0f766e"; } }}
              onMouseLeave={e => { if (!on) { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "#475569"; } }}
              style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 10, padding: "12px 16px", borderRadius: 10, border: "none",
                background: on ? "#0f766e" : "transparent", color: on ? "#fff" : "#475569", boxShadow: on ? "0 6px 16px rgba(15,118,110,.28)" : "none",
                fontWeight: 900, fontSize: 14.5, cursor: on ? "default" : "pointer", fontFamily: "inherit", transition: "background .15s, color .15s" }}>
              <span style={{ fontSize: 20, lineHeight: 1 }}>{t.icon}</span>
              <span style={{ textAlign: "right", lineHeight: 1.35 }}>
                <span style={{ display: "block" }}>{t.title}</span>
                <span style={{ display: "block", fontSize: 11, fontWeight: 700, opacity: on ? 0.85 : 0.7 }}>{t.sub}</span>
              </span>
            </button>); })}
        </div>
        <div style={{ height: 6 }} />
      </div>
      <Page key={active.key} />
    </div>
  );
}
